import React, { useState } from "react";
import FormTextField from "src/shared/components/FormTextField";
import ConfigModalLayout from "./ConfigModalLayout";
import { AddProps } from "../types";

const AddConfigModal: React.FC<AddProps> = ({ open, onClose, onSave }) => {
  const [conname, setConname] = useState("");
  const [convalue, setConvalue] = useState<number | "">("");

  const handleSave = () => {
    if (conname && convalue !== "") {
      onSave(conname, Number(convalue));
      setConname("");
      setConvalue("");
      onClose();
    }
  };

  const isConfirmDisabled = !conname || convalue === "";

  return (
    <ConfigModalLayout open={open} onClose={onClose} title="Add Configuration" confirmLabel="Confirm" confirmVariant="primary" onConfirm={handleSave} confirmDisabled={isConfirmDisabled}>
      <FormTextField id="config-name" label="Configuration Name" value={conname} onChange={(e) => setConname(e.target.value)} required />
      <FormTextField
        id="config-value"
        label="Configuration Value"
        value={convalue === "" ? "" : String(convalue)}
        onChange={(e) => setConvalue(e.target.value === "" ? "" : Number(e.target.value))}
        type="number"
        required
      />
    </ConfigModalLayout>
  );
};

export default AddConfigModal;
